const pad2 = (value) => String(value).padStart(2, '0');

export const shanghaiDateKey = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const byType = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${byType.year}-${byType.month}-${byType.day}`;
};

export const shiftDateKey = (dateKey, deltaDays) => {
  const [year, month, day] = String(dateKey).split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() + deltaDays);
  return `${date.getUTCFullYear()}-${pad2(date.getUTCMonth() + 1)}-${pad2(date.getUTCDate())}`;
};

export const createDefaultCustomRange = () => {
  const to = shanghaiDateKey();
  return { from: shiftDateKey(to, -6), to };
};

export const buildUsageRangeQuery = (rangeKey, customRange) => {
  if (rangeKey === 'today') return { days: 1 };
  if (rangeKey === '7d') return { days: 7 };
  if (rangeKey === '30d') return { days: 30 };
  if (rangeKey === 'all') return {};
  const from = customRange?.from || '';
  const to = customRange?.to || '';
  if (!from || !to) throw new Error('请选择完整的开始和结束日期');
  if (from > to) throw new Error('开始日期不能晚于结束日期');
  return { from, to };
};

export const buildOverviewTimestamps = (rangeKey, customRange) => {
  const today = shanghaiDateKey();
  let from;
  let to = today;
  if (rangeKey === 'today') from = today;
  else if (rangeKey === '7d') from = shiftDateKey(today, -6);
  else if (rangeKey === '30d') from = shiftDateKey(today, -29);
  else if (rangeKey === 'all') return [null, Date.now()];
  else {
    const query = buildUsageRangeQuery(rangeKey, customRange);
    from = query.from;
    to = query.to;
  }

  const startTime = new Date(`${from}T00:00:00+08:00`).getTime();
  const endTime = new Date(`${shiftDateKey(to, 1)}T00:00:00+08:00`).getTime() - 1;
  return [startTime, endTime];
};
